import { Injectable } from '@angular/core';
import { IAccount, IAccountFreeze } from '@app/shared/models/banking.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { IClearContext } from './interface/iclear-context.interface';

@Injectable({
  providedIn: 'root',
})
export class AccountContext implements IClearContext {
  //#region Accounts

  private readonly _accounts$ = new BehaviorSubject<IAccount[] | null>(null);

  public setAccounts(value: IAccount[]): void {
    this._accounts$.next(value);
  }

  public getAccounts(): IAccount[] | null {
    return this._accounts$.getValue();
  }

  public getAccountByCode(accountCode: string): IAccount | null {
    return this.getAccounts()?.find(c => c.code === accountCode) || null;
  }

  public getAccountByIndex(index: number): IAccount | null {
    const accounts = this.getAccounts();

    return accounts ? accounts[index] : null;
  }

  //#endregion

  //#region Account Code Change

  private _accountCodeChanged$ = new BehaviorSubject<string | null>(null);
  public accountCodeChanged$ = this._accountCodeChanged$.asObservable();

  constructor() {}

  accountCodeChange(accountCode: string | null = null): void {
    this._accountCodeChanged$.next(accountCode);
  }

  getAccountCode(): string | null {
    return this._accountCodeChanged$.getValue();
  }

  //#endregion

  //#region Account  Change

  private _accountChanged$ = new BehaviorSubject<IAccount | null>(null);
  public accountChanged$ = this._accountChanged$.asObservable();

  accountChange(account: IAccount | null = null): void {
    this._accountChanged$.next(account);
  }

  getCurrentAccount(): IAccount | null {
    return this._accountChanged$.getValue();
  }

  //#endregion

  //#region Account Freeze

  private readonly _accountFreeze$ = new BehaviorSubject<IAccountFreeze[]>([]);
  public accountFreeze$ = this._accountFreeze$.asObservable();

  setAccountFreeze(value: IAccountFreeze[]): void {
    this._accountFreeze$.next(value);
  }

  getAccountFreeze(): IAccountFreeze[] {
    return this._accountFreeze$.getValue();
  }

  //#endregion

  clear(): void {
    this._accounts$.next(null);
    this._accountCodeChanged$.next(null);
    this._accountChanged$.next(null);
    this._accountFreeze$.next([]);
  }
}
